export const NetworkConstants = {
  SetLastRequest: 'NETWORK_CONSTANTS.SET_LAST_REQUEST',
  ClearLastRequest: 'NETWORK_CONSTANTS.CLEAR_LAST_REQUEST',
};
